export default "__VITE_ASSET__39b25ef3__"